<p-toast></p-toast>
<div class="grid">
    <div class="col-12">

        <p-card>
            <div class="mb-4 flex align-items-center justify-content-between gap-4">
                <h5 class="my-1">Approbation des commandes</h5>
                <p-selectButton [options]="viewOptions" [(ngModel)]="value" optionLabel="label" optionValue="value" />
            </div>
            <div class="flex align-content-center flex-wrap gap-2 my-2">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="onSearch($event)" placeholder="Recherche..." />
                </span>
                <p-button icon="pi pi-refresh" text (click)="refresher()" pTooltip="Rafraîchir la liste" />
            </div>
            <p-card *ngIf="!EstCharge()">
                <div class="fluid formgrid grid">
                    <div class="flex flex-column gap-2 col-12 text-center">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                </div>
            </p-card>
            <!-- Table View -->
            <div *ngIf="value() === 'tableau'">
                <p-table #dt [value]="listeEmplacementsActifs" [columns]="selectedColumns" dataKey="emplacementId"
                    tableStyleClass="tableNormale" autoLayout="true" styleClass="p-datatable-sm p-datatable-striped"
                    [rowHover]="true" [filterDelay]="0" [globalFilterFields]="['nom','code']">
                    <ng-template pTemplate="header" let-columns>
                        <tr>

                            <th pSortableColumn="code">
                                <div class="flex justify-content-between align-items-center">
                                    Numéro
                                    <p-sortIcon field="code"></p-sortIcon>
                                    <p-columnFilter type="text" field="code" display="menu" class="ml-auto">
                                    </p-columnFilter>
                                </div>
                            </th>

                            <th pSortableColumn="nom">
                                <div class="flex justify-content-between align-items-center">
                                    Emplacement
                                    <p-sortIcon field="nom"></p-sortIcon>
                                    <p-columnFilter type="text" field="nom" display="menu" class="ml-auto">
                                    </p-columnFilter>
                                </div>
                            </th>
                            <th pSortableColumn="nombre">
                                <div class="flex justify-content-between align-items-center">
                                    Nombre d'item
                                    <p-sortIcon field="nombre"></p-sortIcon>
                                    <p-columnFilter type="text" field="nombre" display="menu" class="ml-auto">
                                    </p-columnFilter>
                                </div>
                            </th>
                            <th style="min-width: 5rem; width: 5rem;"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-commande>
                        <tr [pContextMenuRow]="commande">
                            <!-- <td>
							<p-tableCheckbox [value]="Item"></p-tableCheckbox>
                        </td> -->

                            <td>
                                <a *ngIf="estAutorise('approbation_precommande_detail')"
                                    [routerLink]="'/commandes/approbation/' + commande.emplacementId">{{commande.code}}</a>
                                <span *ngIf="!estAutorise('approbation_precommande_detail')">
                                    {{commande.code}}
                                </span>
                            </td>

                            <td>{{commande.nom}}</td>
                            <td>{{commande.nombre}}</td>
                            <td>
                                <button *ngIf="estAutorise('approbation_precommande_detail')" pButton pRipple
                                    icon="pi pi-eye" class="p-button-success mr-2 boutonGrille"
                                    (click)="OuvrirDetailCommande(commande.emplacementId)"></button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="3">Aucune commande à approuver.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            <!-- Card View -->
            <div *ngIf="value() === 'cartes'">
                <div class="grid">
                    <div *ngFor="let emplacement of listeEmplacementsFiltres" class="col-12 md:col-6 lg:col-4">
                        <p-card styleClass="h-full cursor-pointer"
                            (click)="OuvrirDetailCommande(emplacement.emplacementId)">
                            <div class="flex justify-content-between gap-4 flex-wrap">
                                <div class="flex align-items-center gap-2" style="height: fit-content;">
                                    <i class="pi pi-map-marker text-xl"></i>
                                    <div>
                                        <h6 class="mb-1">{{ emplacement.code }}</h6>
                                        <p class="text-600 text-sm mb-0">{{ emplacement.nom }}</p>
                                    </div>
                                </div>
                                <div class="flex align-items-center">
                                    <div class="text-center">
                                        <div class="text-2xl font-bold text-900 mb-1">{{ emplacement.nombre || 0 }}
                                        </div>
                                        <div class="text-500 text-sm">Items</div>
                                    </div>
                                </div>
                            </div>
                        </p-card>
                    </div>
                </div>

                <div *ngIf="listeEmplacementsFiltres && listeEmplacementsFiltres.length === 0" class="text-center py-4">
                    <i class="pi pi-info-circle text-6xl text-400 mb-3"></i>
                    <p class="text-600">
                        <span *ngIf="searchTerm">Aucun résultat trouvé pour "{{ searchTerm }}".</span>
                        <span *ngIf="!searchTerm">Aucune pré-commande disponible.</span>
                    </p>
                </div>
            </div>
        </p-card>
    </div>


</div>